//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  isEmpty,
} from "@/utils/validate";
export default {
  data() {
    return {
      Elite: true,
      isLogin: false, // 是否登录
      logoImg: require('../../static/picture/header-logo.png'),
      codeIconImg: require('../../static/picture/code_icon.png'),
      codeImg: require('../../static/picture/code.png'),
      // money:['999元', '3899元', '5699元', '28999元', '899元'],
      money:['***元', '****元', '****元', '****元', '***元'],
      tableData: [
        { id: 1, accountType: '模块'},
        { id: 2, accountType: '商标查询', youth: true, professional: true, elite: true, supreme: true },
        { id: 3, accountType: '批量查询', youth: '—', professional: true, elite: true, supreme: true },
        { id: 4, accountType: '国际商标查询', youth: '—', professional: true, elite: true, supreme: true},
        { id: 5, accountType: '图形查询', youth: '—', professional: true, elite: true, supreme: true},
        { id: 6, accountType: '商品分类', youth: true, professional: true, elite: true, supreme: true },
        { id: 7, accountType: '商标对比', youth: true, professional: true, elite: true, supreme: true },
        { id: 8, accountType: '商标公告', youth: true, professional: true, elite: true, supreme: true },
        { id: 9, accountType: '裁定文书', youth: true, professional: true, elite: true, supreme: true },
        { id: 10, accountType: '商标监控', youth: '—', professional: true, elite: true, supreme: true },
        { id: 11, accountType: '商标分析', youth: '—', professional: true, elite: true, supreme: true },
        { id: 12, accountType: '业务线索/品牌风险', youth: '—', professional: true, elite: true, supreme: true},
        { id: 13, accountType: '专项查询', youth: '—', professional: true, elite: true, supreme: true },
        { id: 14, accountType: 'AI助手', youth: '—', professional: true, elite: true, supreme: true},
        { id: 15, accountType: '权益'},
        { id: 16, accountType: '批量查询', youth: '—', professional: '500次/年', elite: '1000次/年', supreme: '无限' },
        { id: 17, accountType: '国际商标查询', youth: '—', professional: '无限', elite: '无限', supreme: '无限'},
        { id: 18, accountType: '图形查询', youth: '—', professional: '3000次/年', elite: '5000次/年', supreme: '无限'},
        { id: 19, accountType: '商标公告', youth: '1000次/年', professional: '无限', elite: '无限', supreme: '无限' },
        { id: 20, accountType: '商标监控', youth: '—', professional: '1500个/年', elite: '3000个/年', supreme: '无限' },
        { id: 21, accountType: '企业商标概况', youth: '—', professional: '4000个/年', elite: '8000个/年', supreme: '无限' },
        { id: 22, accountType: '业务线索/品牌风险', youth: '—', professional: '3万条/年', elite: '6万条/年', supreme: '无限' },
        { id: 23, accountType: '专项查询', youth: '—', professional: '无限', elite: '无限', supreme: '无限' },
        { id: 24, accountType: 'AI近似分析', youth: '—', professional: '600次/年', elite: '2000次/年', supreme: '无限'},
      ],
      isOpen: false
    }
  },
  mounted() {
    if (!isEmpty(localStorage.getItem(this.$route.query.token))) {
      localStorage.setItem("uc_token", this.$route.query.token);
      setTimeout(() => {
        location.href = "/";
      }, 0);
      return;
    }
    let token = localStorage.getItem("uc_token");
    if (!isEmpty(token) && token != "undefined" && token != "null") {
      this.getUserInfo();
    } else {
      this.isLogin = false;
      localStorage.setItem("uc_token", "");
    }
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }){
       // 第一行（模块）需要跨列显示
    if (rowIndex === 0 || rowIndex === 14) {
      // 第一列显示"模块"并跨5列
      if (columnIndex === 0) {
        return [1, 5]; // rowspan=1, colspan=5
      } else {
        // 其他列隐藏
        return [0, 0]; // rowspan=0, colspan=0
      }
    }
    // 其他行正常显示
    return [1, 1];
    },
    tableRowClassName({row, rowIndex}){
      // 基数行返回 'odd-row'，偶数行返回 'even-row'
      return rowIndex % 2 === 0 ? 'odd-row' : 'even-row';
    },
    getUserInfo() {
      this.$axios
        .post("/api/auth/getUserInfo", { isGoLogin: true })
        .then(res => {
          this.$store.commit("setUser", res.data.data);
          this.isLogin = res.data.code === 0;
        });
    },
    isString(value){
      return typeof value === "string";
    },
    openTool(){

    }
  }
}
